// Add your custom JS here.
// Category Filtering
(function($) {
  let category;
  var ajaxUrl = "/wp-admin/admin-ajax.php";
  var ppp = 4; // Post per page
  let currentPage = 1;

  function loadMore(paged, container) {
    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'json',
      data: {
        action: 'more_post_ajax',
        paged: paged,
        category: category,
      },
      success: function (res) {
        // $('.post-tiles').append(res);

        if(paged >= res.max) {
          $("#more_posts").attr("disabled",true);
        }
        $('.post-tiles').append(res.html);
        // $("#more_posts").attr("disabled",false);
      }
    });
  }

  function filterPosts() {
    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      dataType: 'json',
      ppp: ppp,
      data: {
        action: 'filter_posts',
        category: category,
      },
      success: function(res) {
        console.log("successful!!")
        $('.post-tiles').html(res.html);
        if (res.max === 1) {
          $("#more_posts").attr("disabled", true);
        } else {
          $("#more_posts").attr("disabled",false);
        }
      }
    })
  }

  function changePillText(id, content)
  {
    document.getElementById(id).innerHTML = content;
  }

  $('.cat-list_item').on('click', function() {
    currentPage = 1;
    category = $(this).data('slug');

    $('.cat-list_item').removeClass('active');
    $(this).addClass('active');
    createCookie('category', category , 30);
    
    filterPosts();
    let buttonVal = $(this).val();
    changePillText('categorySection', buttonVal);
    
  });

  $('.cat-list-select').on('change', function() {
    currentPage = 1;
    category = $(this).val();

    $('.cat-list_item').removeClass('active');
    $(this).addClass('active');
    createCookie('category', category , 30);
    
    filterPosts();
    let buttonVal = $(this).val();
    changePillText('categorySection', buttonVal);
    
  });

  $("#more_posts").on("click", function() { // When btn is pressed.
console.log('load more clicked');
    loadMore(currentPage + 1, category);
    currentPage++;

  });
  $("#more_logos").on("click",function() { // When btn is pressed.

    loadMore(currentPage + 1, category);
    currentPage++;

  });

  $(".mixedContent_item").on("click", function() {
    currentPage = 1;
    category = $(this).data('slug');

    $('.mixedContent_item').removeClass('active');
    $(this).addClass('active');

    createCookie('mixedContent', category , 30);
  })

  $(".mixedContent_item_select").on("change", function() {
    currentPage = 1;
    category = $(this).val();
    console.log('select updated');

    $('.mixedContent_item').removeClass('active');
    $(this).addClass('active');

    createCookie('mixedContent', category , 30);
    
  })

   $(document).ready(function () {
    $('.second-button').on('click', function () {
      console.log('nav clicked');
      $('.animated-icon2').toggleClass('open');
      $('#wrapper-navbar').toggleClass('opened');
    });

    $('.mixedContent_buttons button').on('click', function () {
      let contentType = $(this).attr("data-contentTypeBTN");
      console.log("contentType = " + contentType);
      // $('.mixedContent_buttons button[data-contentType="' + contentType + '"]').toggleClass('active');
      $('.mixedContent div').removeClass('active');
      $('.mixedContent div[data-contentType="' + contentType + '"]').addClass('active');
    });
    $('.mixedContent_item_select').on('change', function () {
      let contentType = $(this).val();
      console.log("contentType = " + contentType);
      // $('.mixedContent_buttons button[data-contentType="' + contentType + '"]').toggleClass('active');
      $('.mixedContent div').removeClass('active');
      $('.mixedContent div[data-contentType="' + contentType + '"]').addClass('active');
    });
 



    // Select and loop the containers element of the elements you want to equalise
    $('.fixedScrollNav ul').each(function(){  
      // Cache the highest
      var min_highestBox = 0;
      // Select and loop the elements you want to equalise
      $('.scrollNavItem', this).each(function(){
        // If this box is higher than the cached highest then store it
        if($(this).height() > min_highestBox) {
          min_highestBox = $(this).height(); 
        }
      });  
             
      // Set the height of all those children to whichever was highest 
      $('.scrollNavItem',this).height(min_highestBox);
    }); 




    //scroll to category section if url parameter exists
let queryString = document.location.search;
let urlParams = new URLSearchParams(queryString);
let categoryParam = urlParams.get('category');
let scrollPage = urlParams.get('scroll');
let mixedContentParam = urlParams.get('mixedContent');
console.log('scroll = ' + scrollPage);
let categoryListArray;
if(scrollPage == 1) {
  // if(categoryListArray.indexOf(categoryParam) !== -1 || categoryListArray.indexOf(mixedContentParam) !== -1 ) {
    document.getElementById('categorySection').scrollIntoView();
  // }
}

  });

  $('.dropdown-toggle').removeAttr('data-toggle');
  $('a.nav-link.dropdown-toggle').click(function() {
    location.href = this.href;


});

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


//if postGrid ID exists
const postGridExists= document.getElementById("postGrid");
if(!!postGridExists) {
  console.log('Post Grid exists')
  //check for category cookie
  let catCookieValue = document.cookie
  .split('; ')
  .find(row => row.startsWith('category='))
  ?.split('=')[1];
  

  //add active class to button
  $('.cat-list_item[data-slug="' + catCookieValue + '"]').addClass('active');
}


//if mixedContent ID exists
const mixedContentExists= document.getElementById("mixedContent");
if(!!mixedContentExists) {
  console.log('mixed content exists')
  //check for category cookie
  let cookieValue = document.cookie
  .split('; ')
  .find(row => row.startsWith('mixedContent='))
  ?.split('=')[1];
  

  //add active class to div to show
  // $('.mixedContent div').removeClass('active');
      $('.mixedContent div[data-contentType="' + cookieValue + '"]').addClass('active');

  // $('.mixedContent_item').removeClass('active');
  $('.mixedContent_item[data-contenttypebtn="' + cookieValue + '"]').addClass('active');
}


  var controller = new ScrollMagic.Controller({loglevel: 3});

  let navItem = 1;
  $('.scrollNavItem').each(function() {

    new ScrollMagic.Scene({triggerElement: "#sec" + navItem, duration: $("#sec" + navItem).height()})
		.setClassToggle("#high" + navItem, "active") // add class toggle
		// .addIndicators() 
		.addTo(controller)
    .on("progress", function (event) {
      if(event.state === 'BEFORE') {
        $('.scrollNavItem').removeClass('keepActive')
        $('.scrollNavItem').first().addClass('keepActive')
      } else if(event.state === 'AFTER'){
        $('.scrollNavItem').removeClass('keepActive')
        $('.scrollNavItem').last().addClass('keepActive')
      }
      else{
        $('.scrollNavItem').removeClass('keepActive')
      }
    });
    navItem ++;
  });

  const verticalTabs = document.getElementById("fixedScroll");
  if(verticalTabs !== null) {
  // new ScrollMagic.Scene({triggerElement: "#fixedScroll", duration: $("#fixedScroll").height()})
  new ScrollMagic.Scene({triggerElement: "#fixedScroll", duration: $("#fixedScroll").height() - ($("#sec3").height())})
		.setPin("#fixedScroll ul")
    // .setClassToggle("#fixedScroll ul", "active")
    .offset(($("#sec1").height())/2)
    .setClassToggle(".fixedScrollNav ul", "stactic")
		// .addIndicators() 
		.addTo(controller);

    new ScrollMagic.Scene({triggerElement: "#fixedScroll", duration: $("#fixedScroll").height()})
    .setClassToggle(".fixedScrollNav ul", "stactic")
		// .addIndicators() // add indicators (requires plugin)
		.addTo(controller)
    .on("progress", function (event) {
      if(event.scrollDirection === 'REVERSE') {
        $(".fixedScrollNav").addClass("scrolling-up");
      } else {
        $(".fixedScrollNav").removeClass("scrolling-up");
      }
    })
    .on("progress", function (event) {
      console.log('target = ' + event.state)
      if(event.state === 'BEFORE') {
        $('.scrollNavItem').removeClass('keepActive')
        $('.scrollNavItem').first().addClass('keepActive')
      } else if(event.state === 'AFTER'){
        $('.scrollNavItem').removeClass('keepActive')
        $('.scrollNavItem').last().addClass('keepActive')
      }
      else{
        $('.scrollNavItem').removeClass('keepActive')
      }
    });
  }




})(jQuery);


function createCookie(name, value, days) {
  var expires;
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
  }
  else {
      expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(c_name) {
  if (document.cookie.length > 0) {
      c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) {
              c_end = document.cookie.length;
          }
          return unescape(document.cookie.substring(c_start, c_end));
      }
  }
  return "";
}

import AOS from 'aos/dist';

AOS.init();

import Splide from '@splidejs/splide';
var SplideExists = document.getElementById("card-slider");
if(SplideExists !== null) {
  new Splide( '.splide', {
    padding: '20%',
    gap: '2rem',
    type   : 'loop',
    perPage: 1,
    arrows: true,
    pagination: false
  } ).mount();
}








